import React from 'react';
import { sort } from 'utils/sort';
import Criterion from './Criterion';

const Criteria = props => {
  const sortedCriteria = sort(props.criteria, 'name');
  return (
    <>
      {sortedCriteria.map(criterion => (
        <Criterion
          position={sortedCriteria.indexOf(criterion) + 1}
          criterion={criterion}
          key={criterion.id}
        />
      ))}
    </>
  );
};

export default Criteria;
